import { Box, Stack, useTheme } from "@compass/core";
import { useMediaQuery } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import {
  authContentAreaStyles,
  authPageContainerStyles,
  mobileContentWrapperStyles,
  mobileBrandingContainerStyles,
  envInfoContainerStyles,
} from "../pages/auth/styles/authStyles";
import { LoginSidePanel } from "../pages/auth/components/LoginSidePanel";
import { ForgotCredentialSidePanel } from "../pages/auth/components/ForgotCredentialSidePanel";
import { BrandingHeader } from "../pages/auth/components/BrandingHeader";
import { EnvInfo } from "../pages/auth/LoginPage/EnvInfo";

export const AuthLayout = () => {
  const theme = useTheme();
  const location = useLocation();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isForgotCredentialPage = location.pathname.includes("forgotCredential");

  if (isDesktop) {
    return (
      <Stack className="auth-layout" sx={authPageContainerStyles}>
        {isForgotCredentialPage ? <ForgotCredentialSidePanel /> : <LoginSidePanel />}
        <Box sx={authContentAreaStyles}>
          <Outlet />
          <Box sx={envInfoContainerStyles}>
            <EnvInfo />
          </Box>
        </Box>
      </Stack>
    );
  }

  // Mobile layout: vertical stack with branding above content
  return (
    <Stack className="auth-layout" sx={authPageContainerStyles}>
      <Box sx={authContentAreaStyles}>
        <Stack sx={mobileContentWrapperStyles}>
          <Box sx={mobileBrandingContainerStyles}>
            <BrandingHeader />
          </Box>
          <Outlet />
        </Stack>
        <Box sx={envInfoContainerStyles}>
          <EnvInfo />
        </Box>
      </Box>
    </Stack>
  );
};